const BotRole = Object.freeze({
  USER: 'user',
  ASSISTANT: 'assistant',
} as const);

export type BotRole = (typeof BotRole)[keyof typeof BotRole];

export default BotRole;
